import React, { useEffect, useRef } from 'react'
import {
  faCheck,
  faCheckDouble,
  faClock,
} from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { PixelDiv, PixelFlexBox, PixelIcon, PixelText } from 'pixel-base'
import useScrollToBottom from 'shared/hooks/useScrollToBottom'
import styled, { css } from 'styled-components'

import Icon from '../../../../../common/components/icons/index'

interface IProps {
  onShowBottomIcon: () => void
  shouldScrollToBottom?: boolean
  messages: Message[]
  handleGetActiveNumber: (number: string) => void
}

export default function MessagesList(props: IProps) {
  const {
    onShowBottomIcon,
    shouldScrollToBottom,
    handleGetActiveNumber,
    messages,
  } = props
  const [popupValue, setPopupValue] = React.useState([])
  const [isModalVisible, setIsModalVisible] = React.useState(false)
  const messageInfoRef = useRef(null)
  const { containerRef } = useScrollToBottom(
    onShowBottomIcon,
    shouldScrollToBottom,
  )

  const [clickedMessage, setClickedMessage] = React.useState()

  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight
    }
  }

  const handleReceivedTimeClick = (message) => {
    setClickedMessage(message)
    const popupContent = []
    if (message.message_type === 'send') {
      if (message.failed_at !== null) {
        popupContent.push({ key: 'Failed', value: message.failed_reason })
      } else {
        popupContent.push(
          {
            key: 'Sent',
            value: message.sent_at ? message?.sent_at : '---',
          },
          {
            key: 'Delivered',
            value: message.delivered_at ? message.delivered_at : '---',
          },
          {
            key: 'Read',
            value: message.read_at ? message.read_at : '---',
          },
        )
      }
    } else if (message.message_type === 'receive') {
      popupContent.push({
        key: 'Received',
        value: message.received_at ? message.received_at : '---',
      })
    }
    setPopupValue(popupContent)
    setIsModalVisible(!isModalVisible)
  }

  function formatDate(dateString) {
    if (dateString !== '---') {
      const date = moment(dateString)
      let formatString
      if (date.isSame(moment(), 'day')) {
        formatString = '[Today] hh:mm a'
      } else if (date.isSame(moment().subtract(1, 'days'), 'day')) {
        formatString = '[Yesterday] hh:mm a'
      } else {
        formatString = 'DD/MM/YYYY hh:mm a'
      }

      return moment(dateString).format(formatString)
    } else {
      return '---'
    }
  }

  useEffect(() => {
    handleGetActiveNumber(messages[0].customer_number)
  }, [messages])
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        messageInfoRef.current &&
        !messageInfoRef.current.contains(event.target)
      ) {
        setIsModalVisible(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    scrollToBottom()
  }, [shouldScrollToBottom])

  return (
    <Container ref={containerRef}>
      <EncryptionMessage style={{ background: '#fdf4c5' }}>
        <Icon id="lock" className="icon" />
        Messages are end-to-end encrypted. No one outside of this chat, not even
        WhatsApp, can read or listen to them. Click to learn more.
      </EncryptionMessage>
      <DateWrapper>
        <Date style={{ background: '#e1f2fa' }}>
          {' '}
          {formatDate(messages[0].created_at)}{' '}
        </Date>
      </DateWrapper>
      <MessageGroup>
        {messages.map((message, index) => (
          <React.Fragment key={index}>
            <PixelFlexBox
              style={{
                position: 'relative',
                flexDirection: 'column',
                alignItems:
                  message.message_type === 'send' ? 'flex-end' : 'flex-start',
              }}
              key={index}
              type={message.message_type}
            >
              <div
                style={{
                  backgroundColor:
                    message.message_type === 'send' ? '#dcf8c6' : '#f5f5f5',
                  width: 'fit-content',
                  padding: '8px 12px',
                  borderRadius: '5px',
                  margin: '4px',
                  flexDirection: 'row',
                  gap: '20px',
                  display: 'flex',
                  alignItems:
                    message.message_type === 'send' ? 'flex-end' : 'flex-end',
                }}
              >
                <PixelText
                  style={{
                    fontSize: '16px',
                    alignSelf:
                      message.message_type === 'send'
                        ? 'flex-end'
                        : 'flex-start',
                    textAlign:
                      message.message_type === 'send' ? 'right' : 'left',
                    marginBottom: '4px',
                  }}
                >
                  {message.message}
                </PixelText>
                <PixelText
                  style={{
                    fontSize: '12px',
                    color: '#888',
                    textAlign:
                      message.message_type === 'send' ? 'right' : 'left',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleReceivedTimeClick(message)}
                >
                  {message.message_type === 'receive'
                    ? message.received_at && message.received_at
                      ? moment(message.received_at).format('LT')
                      : moment(message.created_at).format('LT')
                    : message.sent_at && message?.sent_at
                    ? moment(message.sent_at).format('LT')
                    : moment(message.created_at).format('LT')}{' '}
                  <PixelIcon
                    icon={
                      message.failed_at !== null
                        ? faClock
                        : message.read_at !== null
                        ? faCheckDouble
                        : message.delivered_at !== null
                        ? faCheckDouble
                        : message.sent_at !== null
                        ? faCheck
                        : ''
                    }
                    color={
                      message.failed_at !== null
                        ? 'red'
                        : message.read_at !== null
                        ? '#0da9e5'
                        : message.delivered_at !== null
                        ? 'gray'
                        : message.sent_at !== null
                        ? 'gray'
                        : 'gray'
                    }
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleReceivedTimeClick(message)}
                  />
                </PixelText>
              </div>
              {isModalVisible && clickedMessage === message && (
                <div
                  ref={messageInfoRef}
                  style={{
                    backgroundColor: '#EDEDED',
                    boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
                    width: '255px',
                    height: 'fit-content',
                    position: 'absolute',
                    borderRadius: '5px',
                    zIndex: '55',
                    top: '93%',
                    right: message.message_type === 'send' ? '6%' : '',
                    padding: '5px',
                  }}
                >
                  {popupValue.map((item) => {
                    return (
                      <PixelDiv
                        key="item.key"
                        style={{
                          padding: ' 5px',
                          textAlign: 'left',
                          display: 'flex',
                          gap: '5px',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div
                          style={{
                            width: '40%',
                            display: 'flex',
                            gap: '10px',
                          }}
                        >
                          <PixelIcon
                            icon={
                              item.key == 'Read'
                                ? faCheckDouble
                                : item.key == 'Delivered'
                                ? faCheckDouble
                                : item.key == 'Sent'
                                ? faCheck
                                : item.key == 'Failed'
                                ? faClock
                                : null
                            }
                            color={
                              item.key == 'Read'
                                ? '#0da9e5'
                                : item.key == 'Delivered'
                                ? 'gray'
                                : item.key == 'Sent'
                                ? 'gray'
                                : item.key == 'Failed'
                                ? 'red'
                                : 'gray'
                            }
                            style={{
                              cursor: 'pointer',
                            }}
                            onClick={() => handleReceivedTimeClick(message)}
                          />
                          <div
                            style={{
                              fontWeight: 'bold',
                              color: 'black',
                              textAlign: 'left',
                              fontSize: '12px',
                            }}
                          >
                            {item.key}
                          </div>
                        </div>

                        <div
                          style={{
                            textAlign: 'center',
                            fontSize: '12px',
                            width: '60%',
                          }}
                        >
                          {message.failed_at === null
                            ? formatDate(item.value)
                            : item.value}
                        </div>
                      </PixelDiv>
                    )
                  })}
                </div>
              )}
            </PixelFlexBox>

            <PixelDiv
              style={{
                position: 'relative',
                display: 'flex',
                justifyContent:
                  message.message_type == 'send' ? 'flex-end' : 'flex-start',
                marginTop: '-5px',
                marginRight: '7px',
              }}
            >
              {message.reaction && (
                <PixelText
                  style={{
                    backgroundColor: '#f0f0f0',
                    color: '#333',
                    fontSize: '12px',
                    padding: '2px 2px',
                    borderRadius: '5px',
                  }}
                >
                  {message.reaction}
                </PixelText>
              )}
            </PixelDiv>
          </React.Fragment>
        ))}
      </MessageGroup>
    </Container>
  )
}

const Container = styled.div`
  flex: 1;
  position: relative;
  /* background: #e4dcd4; */
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 20px 5% 2pc;

  .icon {
    //   color:  "#00000099";
    margin-right: 5px;
    margin-bottom: -1px;
  }
`

const wrapperStyles = css`
  z-index: 9;
`

const DateWrapper = styled.div`
  text-align: center;
  margin: 10px 0 14px;
  position: relative;
  ${wrapperStyles}
`

const Date = styled.span`
  background: '#e1f2fa';
  display: inline-block;
  color: '#000';
  font-size: 0.75rem;
  padding: 7px 10px;
  border-radius: 5px;
`

const EncryptionMessage = styled.p`
  background: '#fdf4c5';
  color: '#000';
  font-size: 0.77rem;
  text-align: center;
  padding: 5px 10px;
  position: relative;
  margin-bottom: 8px;
  border-radius: 5px;
  line-height: 20px;

  ${wrapperStyles}
`

const MessageGroup = styled.div`
  ${wrapperStyles}

  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  position: relative;

  .chat__msg--sent {
    background: '#dbf8c6';
    align-self: flex-end;
  }

  .chat__msg--received {
    background: 'white';
    align-self: flex-start;
  }

  & > *:nth-child(1):not(.chat__msg--sent)::before,
  .chat__msg--sent + .chat__msg--received::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    left: -8px;
    border-top: 6px solid 'white';
    border-right: 6px solid 'white';
    border-bottom: 6px solid transparent;
    border-left: 6px solid transparent;
  }

  & > *:nth-child(1):not(.chat__msg--received)::before,
  .chat__msg--received + .chat__msg--sent::before {
    right: -8px;
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    border-top: 6px solid '#dbf8c6';
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid '#dbf8c6';
  }

  .chat__msg-status-icon {
    color: '#00000099';
    margin-left: 3px;
  }

  .chat__msg-status-icon--blue {
    color: '#0da9e5';
  }
`
